<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>Für Lynn, eine hervorragende Lektorin und ganz besondere Freundin. Die Stunden, in denen wir miteinander geredet haben, haben diese Geschichte möglich gemacht.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?1251e518